import React from 'react';
import { useSourceContext } from 'react-admin';
import { Box, Typography } from '@mui/material';

export const PendingField = ({ children, lockedFields }) => {
  const sourceContext = useSourceContext();
  const source = sourceContext.getSource(children.props.source);
  const parts = source.split('.');
  const key = `${parts[parts.length - 1]}.${parts[parts.length - 2]}`;
  const locked = lockedFields === null || lockedFields.includes(key);
  return <Box>
    {locked && <Typography variant="caption" color="warning.main">
      {lockedFields === null ? 'Checking proposed changes…' : 'Approve or reject the proposed change before editing this field.'}
    </Typography>}
    <Box inert={locked ? '' : undefined} sx={locked ? { opacity: 0.65 } : undefined}>
      {children}
    </Box>
  </Box>;
};

